import type { LucideIcon } from "lucide-react";
import {
  CalendarDays,
  HandHeart,
  Home,
  LayoutGrid,
  Mail,
  TrendingUp,
  User,
} from "lucide-react";

/** Lucide icons for primary site nav links (by href). */
const NAV_ICONS: Record<string, LucideIcon> = {
  "/": Home,
  "/about": HandHeart,
  "/programs": LayoutGrid,
  "/impact": TrendingUp,
  "/events": CalendarDays,
  "/contact": Mail,
  "/account": User,
};

export function getNavIcon(href: string): LucideIcon {
  return NAV_ICONS[href] ?? Home;
}
